import { LEGAL_DOC_URL, LegalDocumentDataType } from '@oy/types';
import { getLegalDocuments } from 'src/clients';
import { documentOrder } from 'src/components/SignLegalDocumentModal/constants';
import useSWR from 'swr';

import { useCheckMAMViewOnlyChildTypeProd } from '../useCheckMAMViewOnlyChildTypeProd';
import { useEnv } from '../useEnv';
import { useUserRole } from '../useUserRole';

export const useLegalDocumentData = () => {
  const { isViewOnlyChildActiveProd } = useCheckMAMViewOnlyChildTypeProd();
  const { isSuperAdmin } = useUserRole();
  const { isProdEnv } = useEnv();

  const { data = [], ...swr } = useSWR(
    isViewOnlyChildActiveProd || !isSuperAdmin ? null : LEGAL_DOC_URL,
    () =>
      getLegalDocuments()
        .then(res => {
          if (res.data.data) {
            return res.data.data;
          }

          return [];
        })
        .catch(() => []),
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      revalidateOnMount: true,
      errorRetryCount: 0,
    },
  );

  const sortByDocumentType = (
    a: LegalDocumentDataType,
    b: LegalDocumentDataType,
  ) => {
    const typeA = a.type.toUpperCase();
    const typeB = b.type.toUpperCase();

    return documentOrder[typeA] - documentOrder[typeB];
  };

  const isNeedToSign = !isProdEnv && data.length > 0;

  const isShow = data.length > 0;
  const isSigned = data.length == 0;

  return {
    ...swr,
    data: data.sort(sortByDocumentType),
    isNeedToSign,
    isShow,
    isSigned,
  };
};
